import React from "react";

const EditIcon = ({ stroke = "white", size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.334 1.99955C11.5091 1.82445 11.7169 1.68556 11.9457 1.5908C12.1745 1.49604 12.4197 1.44727 12.6673 1.44727C12.9149 1.44727 13.1601 1.49604 13.3889 1.5908C13.6177 1.68556 13.8256 1.82445 14.0007 1.99955C14.1757 2.17465 14.3146 2.38252 14.4094 2.61129C14.5042 2.84006 14.5529 3.08526 14.5529 3.33288C14.5529 3.58051 14.5042 3.8257 14.4094 4.05448C14.3146 4.28325 14.1757 4.49112 14.0007 4.66622L5.00065 13.6662L1.33398 14.6662L2.33398 10.9996L11.334 1.99955Z"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EditHighlightsButton = ({ onClick, isLoading, isMobile = false }) => {
  if (isMobile) {
    return (
      <button
        onClick={onClick}
        disabled={isLoading}
        className="flex items-center gap-2 bg-[#2283FF] text-white px-3 py-1.5 rounded-lg text-xs font-medium ml-2 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <EditIcon size={12} />
        {isLoading ? "Loading..." : "Edit"}
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      disabled={isLoading}
      className="flex items-center gap-2 bg-[#2283FF] text-[#F5F5F5] px-4 py-2 rounded-lg font-medium disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <EditIcon stroke="#F5F5F5" />
      {isLoading ? "Loading..." : "Edit Highlights"}
    </button>
  );
};

export default EditHighlightsButton;
